var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotelBookingRafiki1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1520_57147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.875 150.473H0.125V150.572H196.875V150.473Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.161 156.806H164.128V156.904H177.161V156.806Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.461 157.875H127.041V157.974H130.461V157.875Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.735 153.153H156.184V153.252H163.735V153.153Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7628 153.815H20.7676V153.913H37.7628V153.815Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7604 153.815H41.2695V153.913H43.7604V153.815Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7215 155.475H51.8584V155.573H88.7215V155.475Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.846 150.186V130.05H176.122V120.461H173.608V87.1035H169.968V82.8026L162.2 79.1784V74.8381H161.126V87.1035H159.619V120.461H158.112V102.922H154.023V93.8835H152.882V120.461H149.777V110.344H147.735V107.762H143.001V98.94H140.408V92.6991H137.221V83.6092H136.084V92.6991H132.896V98.94H130.303V107.762H125.569V110.344H123.527V120.461H121.099V107.762H116.365V80.4337H114.858V77.4195H104.745V80.4337H102.593V100.231H93.987V102.167H90.7603V103.674H93.987V111.422H84.9483V85.6004H83.0123V80.111H78.8176V60.6367H77.6332V80.111H74.6189V85.6004H56.9587V83.7942H55.8844V96.0596H54.3773V96.2721H53.4723V108.537H51.9651V111.874H48.7817V102.836H47.6406V124.356H46.3696V115.317H45.2284V129.413H44.5359V119.3H42.4897V116.718H37.7559V107.892H35.1627V101.651H31.9793V92.5614H30.8421V101.651H27.6547V107.892H25.0616V116.718H20.3277V119.3H18.2815V129.196H17.9156V129.413H16.9043V150.186H177.846Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0314 86.8057H66.8115V88.0255H68.0314V86.8057Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0314 88.8516H66.8115V90.0714H68.0314V88.8516Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0314 97.0278H66.8115V98.2477H68.0314V97.0278Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0314 99.0698H66.8115V100.29H68.0314V99.0698Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0314 101.117H66.8115V102.337H68.0314V101.117Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0314 107.248H66.8115V108.467H68.0314V107.248Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0314 109.293H66.8115V110.513H68.0314V109.293Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9708 94.9829H68.751V96.2028H69.9708V94.9829Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9708 97.0278H68.751V98.2477H69.9708V97.0278Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9708 99.0698H68.751V100.29H69.9708V99.0698Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9708 101.117H68.751V102.337H69.9708V101.117Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9708 103.159H68.751V104.379H69.9708V103.159Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9708 107.248H68.751V108.467H69.9708V107.248Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9708 109.293H68.751V110.513H69.9708V109.293Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 86.8057H70.6875V88.0255H71.9073V86.8057Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 88.8516H70.6875V90.0714H71.9073V88.8516Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 90.8936H70.6875V92.1134H71.9073V90.8936Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 92.9399H70.6875V94.1598H71.9073V92.9399Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 94.9829H70.6875V96.2028H71.9073V94.9829Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 97.0278H70.6875V98.2477H71.9073V97.0278Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 99.0698H70.6875V100.29H71.9073V99.0698Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 101.117H70.6875V102.337H71.9073V101.117Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 103.159H70.6875V104.379H71.9073V103.159Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 105.205H70.6875V106.425H71.9073V105.205Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9073 109.293H70.6875V110.513H71.9073V109.293Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8439 86.8057H72.624V88.0255H73.8439V86.8057Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8439 88.8516H72.624V90.0714H73.8439V88.8516Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8439 90.8936H72.624V92.1134H73.8439V90.8936Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8439 92.9399H72.624V94.1598H73.8439V92.9399Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8439 94.9829H72.624V96.2028H73.8439V94.9829Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8439 97.0278H72.624V98.2477H73.8439V97.0278Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8439 99.0698H72.624V100.29H73.8439V99.0698Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8439 117.471H72.624V118.691H73.8439V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 86.8057H74.5596V88.0255H75.7794V86.8057Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 88.8516H74.5596V90.0714H75.7794V88.8516Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 90.8936H74.5596V92.1134H75.7794V90.8936Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 92.9399H74.5596V94.1598H75.7794V92.9399Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 94.9829H74.5596V96.2028H75.7794V94.9829Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 97.0278H74.5596V98.2477H75.7794V97.0278Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 99.0698H74.5596V100.29H75.7794V99.0698Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 101.117H74.5596V102.337H75.7794V101.117Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 113.383H74.5596V114.603H75.7794V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 115.425H74.5596V116.645H75.7794V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 117.471H74.5596V118.691H75.7794V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 119.513H74.5596V120.733H75.7794V119.513Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7794 127.69H74.5596V128.91H75.7794V127.69Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 86.8057H76.4961V88.0255H77.7159V86.8057Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 88.8516H76.4961V90.0714H77.7159V88.8516Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 90.8936H76.4961V92.1134H77.7159V90.8936Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 92.9399H76.4961V94.1598H77.7159V92.9399Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 94.9829H76.4961V96.2028H77.7159V94.9829Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 97.0278H76.4961V98.2477H77.7159V97.0278Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 99.0698H76.4961V100.29H77.7159V99.0698Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 101.117H76.4961V102.337H77.7159V101.117Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 103.159H76.4961V104.379H77.7159V103.159Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 105.205H76.4961V106.425H77.7159V105.205Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 111.335H76.4961V112.555H77.7159V111.335Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 113.383H76.4961V114.603H77.7159V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 115.425H76.4961V116.645H77.7159V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 117.471H76.4961V118.691H77.7159V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 119.513H76.4961V120.733H77.7159V119.513Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7159 127.69H76.4961V128.91H77.7159V127.69Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 86.8057H78.4316V88.0255H79.6515V86.8057Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 88.8516H78.4316V90.0714H79.6515V88.8516Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 90.8936H78.4316V92.1134H79.6515V90.8936Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 92.9399H78.4316V94.1598H79.6515V92.9399Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 94.9829H78.4316V96.2028H79.6515V94.9829Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 97.0278H78.4316V98.2477H79.6515V97.0278Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 99.0698H78.4316V100.29H79.6515V99.0698Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 101.117H78.4316V102.337H79.6515V101.117Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 103.159H78.4316V104.379H79.6515V103.159Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 105.205H78.4316V106.425H79.6515V105.205Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 107.248H78.4316V108.467H79.6515V107.248Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 109.293H78.4316V110.513H79.6515V109.293Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 111.335H78.4316V112.555H79.6515V111.335Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 113.383H78.4316V114.603H79.6515V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 115.425H78.4316V116.645H79.6515V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 117.471H78.4316V118.691H79.6515V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 119.513H78.4316V120.733H79.6515V119.513Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6515 121.559H78.4316V122.779H79.6515V121.559Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 86.8057H80.3711V88.0255H81.5909V86.8057Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 88.8516H80.3711V90.0714H81.5909V88.8516Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 90.8936H80.3711V92.1134H81.5909V90.8936Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 92.9399H80.3711V94.1598H81.5909V92.9399Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 94.9829H80.3711V96.2028H81.5909V94.9829Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 97.0278H80.3711V98.2477H81.5909V97.0278Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 99.0698H80.3711V100.29H81.5909V99.0698Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 101.117H80.3711V102.337H81.5909V101.117Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 103.159H80.3711V104.379H81.5909V103.159Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 105.205H80.3711V106.425H81.5909V105.205Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 111.335H80.3711V112.555H81.5909V111.335Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 113.383H80.3711V114.603H81.5909V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 115.425H80.3711V116.645H81.5909V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5909 117.471H80.3711V118.691H81.5909V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 86.8057H82.3076V88.0255H83.5275V86.8057Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 88.8516H82.3076V90.0714H83.5275V88.8516Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 90.8936H82.3076V92.1134H83.5275V90.8936Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 92.9399H82.3076V94.1598H83.5275V92.9399Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 94.9829H82.3076V96.2028H83.5275V94.9829Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 97.0278H82.3076V98.2477H83.5275V97.0278Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 99.0698H82.3076V100.29H83.5275V99.0698Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 101.117H82.3076V102.337H83.5275V101.117Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 103.159H82.3076V104.379H83.5275V103.159Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 105.205H82.3076V106.425H83.5275V105.205Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 111.335H82.3076V112.555H83.5275V111.335Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 113.383H82.3076V114.603H83.5275V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5275 115.425H82.3076V116.645H83.5275V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.331 81.4961H104.111V82.7159H105.331V81.4961Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.331 83.5435H104.111V84.7633H105.331V83.5435Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.331 85.5854H104.111V86.8053H105.331V85.5854Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.331 87.6318H104.111V88.8517H105.331V87.6318Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.331 89.6738H104.111V90.8937H105.331V89.6738Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.331 91.7197H104.111V92.9396H105.331V91.7197Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.331 93.7617H104.111V94.9816H105.331V93.7617Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.331 95.8091H104.111V97.0289H105.331V95.8091Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.331 101.939H104.111V103.159H105.331V101.939Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.331 103.985H104.111V105.205H105.331V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.267 81.4961H106.047V82.7159H107.267V81.4961Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.267 83.5435H106.047V84.7633H107.267V83.5435Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.267 85.5854H106.047V86.8053H107.267V85.5854Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.267 87.6318H106.047V88.8517H107.267V87.6318Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.267 89.6738H106.047V90.8937H107.267V89.6738Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.267 91.7197H106.047V92.9396H107.267V91.7197Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.267 93.7617H106.047V94.9816H107.267V93.7617Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.267 95.8091H106.047V97.0289H107.267V95.8091Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.267 103.985H106.047V105.205H107.267V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.203 81.4961H107.983V82.7159H109.203V81.4961Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.203 83.5435H107.983V84.7633H109.203V83.5435Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.203 85.5854H107.983V86.8053H109.203V85.5854Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.203 87.6318H107.983V88.8517H109.203V87.6318Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.203 89.6738H107.983V90.8937H109.203V89.6738Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.203 91.7197H107.983V92.9396H109.203V91.7197Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.203 93.7617H107.983V94.9816H109.203V93.7617Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.203 95.8091H107.983V97.0289H109.203V95.8091Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 81.4961H109.923V82.7159H111.143V81.4961Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 83.5435H109.923V84.7633H111.143V83.5435Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 85.5854H109.923V86.8053H111.143V85.5854Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 87.6318H109.923V88.8517H111.143V87.6318Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 89.6738H109.923V90.8937H111.143V89.6738Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 91.7197H109.923V92.9396H111.143V91.7197Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 95.8091H109.923V97.0289H111.143V95.8091Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 97.8511H109.923V99.0709H111.143V97.8511Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 103.985H109.923V105.205H111.143V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 106.027H109.923V107.247H111.143V106.027Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 108.075H109.923V109.295H111.143V108.075Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 110.115H109.923V111.335H111.143V110.115Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 112.162H109.923V113.381H111.143V112.162Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 114.208H109.923V115.428H111.143V114.208Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 116.251H109.923V117.471H111.143V116.251Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 81.4961H111.859V82.7159H113.079V81.4961Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 83.5435H111.859V84.7633H113.079V83.5435Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 85.5854H111.859V86.8053H113.079V85.5854Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 87.6318H111.859V88.8517H113.079V87.6318Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 89.6738H111.859V90.8937H113.079V89.6738Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 91.7197H111.859V92.9396H113.079V91.7197Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 97.8511H111.859V99.0709H113.079V97.8511Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 99.897H111.859V101.117H113.079V99.897Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 101.939H111.859V103.159H113.079V101.939Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 103.985H111.859V105.205H113.079V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 106.027H111.859V107.247H113.079V106.027Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 108.075H111.859V109.295H113.079V108.075Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 110.115H111.859V111.335H113.079V110.115Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 112.162H111.859V113.381H113.079V112.162Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 114.208H111.859V115.428H113.079V114.208Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 116.251H111.859V117.471H113.079V116.251Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 118.297H111.859V119.517H113.079V118.297Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 122.385H111.859V123.605H113.079V122.385Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 81.4961H113.795V82.7159H115.015V81.4961Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 83.5435H113.795V84.7633H115.015V83.5435Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 85.5854H113.795V86.8053H115.015V85.5854Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 87.6318H113.795V88.8517H115.015V87.6318Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 89.6738H113.795V90.8937H115.015V89.6738Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 91.7197H113.795V92.9396H115.015V91.7197Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 97.8511H113.795V99.0709H115.015V97.8511Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 99.897H113.795V101.117H115.015V99.897Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 101.939H113.795V103.159H115.015V101.939Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 103.985H113.795V105.205H115.015V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 110.115H113.795V111.335H115.015V110.115Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 112.162H113.795V113.381H115.015V112.162Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 114.208H113.795V115.428H115.015V114.208Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 116.251H113.795V117.471H115.015V116.251Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 118.297H113.795V119.517H115.015V118.297Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 122.385H113.795V123.605H115.015V122.385Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 124.428H113.795V125.648H115.015V124.428Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.589 100.506H131.369V101.726H132.589V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.589 102.549H131.369V103.769H132.589V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.589 104.596H131.369V105.816H132.589V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.589 106.638H131.369V107.858H132.589V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.589 108.684H131.369V109.904H132.589V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.589 110.726H131.369V111.946H132.589V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.589 112.772H131.369V113.992H132.589V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.589 118.903H131.369V120.123H132.589V118.903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.589 120.948H131.369V122.168H132.589V120.948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.589 122.996H131.369V124.215H132.589V122.996Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.526 100.506H133.306V101.726H134.526V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.526 102.549H133.306V103.769H134.526V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.526 104.596H133.306V105.816H134.526V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.526 106.638H133.306V107.858H134.526V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.526 108.684H133.306V109.904H134.526V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.526 110.726H133.306V111.946H134.526V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.526 112.772H133.306V113.992H134.526V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.461 100.506H135.241V101.726H136.461V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.461 102.549H135.241V103.769H136.461V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.461 104.596H135.241V105.816H136.461V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.461 106.638H135.241V107.858H136.461V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.461 108.684H135.241V109.904H136.461V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.461 110.726H135.241V111.946H136.461V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.461 112.772H135.241V113.992H136.461V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 100.506H137.177V101.726H138.397V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 102.549H137.177V103.769H138.397V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 104.596H137.177V105.816H138.397V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 106.638H137.177V107.858H138.397V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 108.684H137.177V109.904H138.397V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 110.726H137.177V111.946H138.397V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 112.772H137.177V113.992H138.397V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 114.814H137.177V116.034H138.397V114.814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 116.861H137.177V118.081H138.397V116.861Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 118.903H137.177V120.123H138.397V118.903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.397 120.948H137.177V122.168H138.397V120.948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 100.506H139.117V101.726H140.337V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 102.549H139.117V103.769H140.337V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 104.596H139.117V105.816H140.337V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 106.638H139.117V107.858H140.337V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 108.684H139.117V109.904H140.337V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 110.726H139.117V111.946H140.337V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 112.772H139.117V113.992H140.337V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 114.814H139.117V116.034H140.337V114.814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 116.861H139.117V118.081H140.337V116.861Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 118.903H139.117V120.123H140.337V118.903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 120.948H139.117V122.168H140.337V120.948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 122.996H139.117V124.215H140.337V122.996Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 129.126H139.117V130.346H140.337V129.126Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.337 131.172H139.117V132.392H140.337V131.172Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 100.506H141.053V101.726H142.273V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 102.549H141.053V103.769H142.273V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 104.596H141.053V105.816H142.273V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 110.726H141.053V111.946H142.273V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 112.772H141.053V113.992H142.273V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 114.814H141.053V116.034H142.273V114.814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 116.861H141.053V118.081H142.273V116.861Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 118.903H141.053V120.123H142.273V118.903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 120.948H141.053V122.168H142.273V120.948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 122.996H141.053V124.215H142.273V122.996Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 129.126H141.053V130.346H142.273V129.126Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 131.172H141.053V132.392H142.273V131.172Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 133.214H141.053V134.434H142.273V133.214Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 88.2412H161.35V89.4611H162.569V88.2412Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 90.2832H161.35V91.503H162.569V90.2832Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 92.3306H161.35V93.5504H162.569V92.3306Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 94.3726H161.35V95.5924H162.569V94.3726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 96.4185H161.35V97.6383H162.569V96.4185Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 98.4604H161.35V99.6803H162.569V98.4604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 100.506H161.35V101.726H162.569V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 102.549H161.35V103.769H162.569V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 104.596H161.35V105.816H162.569V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 106.638H161.35V107.858H162.569V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 108.684H161.35V109.904H162.569V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 110.726H161.35V111.946H162.569V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 112.772H161.35V113.992H162.569V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 114.814H161.35V116.034H162.569V114.814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 116.861H161.35V118.081H162.569V116.861Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 118.903H161.35V120.123H162.569V118.903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 120.948H161.35V122.168H162.569V120.948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 122.996H161.35V124.215H162.569V122.996Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 125.038H161.35V126.257H162.569V125.038Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 127.083H161.35V128.303H162.569V127.083Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 129.126H161.35V130.346H162.569V129.126Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 131.172H161.35V132.392H162.569V131.172Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.569 133.214H161.35V134.434H162.569V133.214Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 88.2412H163.29V89.4611H164.51V88.2412Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 90.2832H163.29V91.503H164.51V90.2832Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 92.3306H163.29V93.5504H164.51V92.3306Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 94.3726H163.29V95.5924H164.51V94.3726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 96.4185H163.29V97.6383H164.51V96.4185Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 98.4604H163.29V99.6803H164.51V98.4604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 100.506H163.29V101.726H164.51V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 102.549H163.29V103.769H164.51V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 104.596H163.29V105.816H164.51V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 106.638H163.29V107.858H164.51V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 108.684H163.29V109.904H164.51V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 110.726H163.29V111.946H164.51V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 112.772H163.29V113.992H164.51V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 114.814H163.29V116.034H164.51V114.814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 116.861H163.29V118.081H164.51V116.861Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 118.903H163.29V120.123H164.51V118.903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 120.948H163.29V122.168H164.51V120.948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 122.996H163.29V124.215H164.51V122.996Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51 125.038H163.29V126.257H164.51V125.038Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 88.2412H165.226V89.4611H166.445V88.2412Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 90.2832H165.226V91.503H166.445V90.2832Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 92.3306H165.226V93.5504H166.445V92.3306Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 94.3726H165.226V95.5924H166.445V94.3726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 96.4185H165.226V97.6383H166.445V96.4185Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 98.4604H165.226V99.6803H166.445V98.4604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 100.506H165.226V101.726H166.445V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 102.549H165.226V103.769H166.445V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 104.596H165.226V105.816H166.445V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 106.638H165.226V107.858H166.445V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 108.684H165.226V109.904H166.445V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 110.726H165.226V111.946H166.445V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 112.772H165.226V113.992H166.445V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 114.814H165.226V116.034H166.445V114.814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 116.861H165.226V118.081H166.445V116.861Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 118.903H165.226V120.123H166.445V118.903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 120.948H165.226V122.168H166.445V120.948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 122.996H165.226V124.215H166.445V122.996Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.445 125.038H165.226V126.257H166.445V125.038Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 88.2412H167.162V89.4611H168.382V88.2412Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 90.2832H167.162V91.503H168.382V90.2832Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 92.3306H167.162V93.5504H168.382V92.3306Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 94.3726H167.162V95.5924H168.382V94.3726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 96.4185H167.162V97.6383H168.382V96.4185Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 98.4604H167.162V99.6803H168.382V98.4604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 100.506H167.162V101.726H168.382V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 102.549H167.162V103.769H168.382V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 104.596H167.162V105.816H168.382V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 106.638H167.162V107.858H168.382V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 108.684H167.162V109.904H168.382V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 110.726H167.162V111.946H168.382V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 112.772H167.162V113.992H168.382V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 114.814H167.162V116.034H168.382V114.814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.382 116.861H167.162V118.081H168.382V116.861Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 88.2412H169.098V89.4611H170.318V88.2412Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 90.2832H169.098V91.503H170.318V90.2832Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 92.3306H169.098V93.5504H170.318V92.3306Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 94.3726H169.098V95.5924H170.318V94.3726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 96.4185H169.098V97.6383H170.318V96.4185Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 98.4604H169.098V99.6803H170.318V98.4604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 100.506H169.098V101.726H170.318V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 102.549H169.098V103.769H170.318V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 104.596H169.098V105.816H170.318V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 106.638H169.098V107.858H170.318V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 108.684H169.098V109.904H170.318V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 110.726H169.098V111.946H170.318V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.318 112.772H169.098V113.992H170.318V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 88.2412H171.034V89.4611H172.254V88.2412Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 90.2832H171.034V91.503H172.254V90.2832Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 92.3306H171.034V93.5504H172.254V92.3306Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 94.3726H171.034V95.5924H172.254V94.3726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 96.4185H171.034V97.6383H172.254V96.4185Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 98.4604H171.034V99.6803H172.254V98.4604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 100.506H171.034V101.726H172.254V100.506Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 102.549H171.034V103.769H172.254V102.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 104.596H171.034V105.816H172.254V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 106.638H171.034V107.858H172.254V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 108.684H171.034V109.904H172.254V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.254 110.726H171.034V111.946H172.254V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 103.159H28.7246V104.379H29.9445V103.159Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 105.205H28.7246V106.425H29.9445V105.205Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 107.248H28.7246V108.467H29.9445V107.248Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 109.293H28.7246V110.513H29.9445V109.293Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 111.335H28.7246V112.555H29.9445V111.335Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 113.383H28.7246V114.603H29.9445V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 115.425H28.7246V116.645H29.9445V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 117.471H28.7246V118.691H29.9445V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 119.513H28.7246V120.733H29.9445V119.513Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 121.559H28.7246V122.779H29.9445V121.559Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 123.601H28.7246V124.821H29.9445V123.601Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 125.648H28.7246V126.868H29.9445V125.648Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 127.69H28.7246V128.91H29.9445V127.69Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 129.735H28.7246V130.955H29.9445V129.735Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 131.778H28.7246V132.998H29.9445V131.778Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 133.825H28.7246V135.045H29.9445V133.825Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 135.871H28.7246V137.09H29.9445V135.871Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 137.913H28.7246V139.132H29.9445V137.913Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 139.958H28.7246V141.178H29.9445V139.958Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9445 142H28.7246V143.22H29.9445V142Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 103.159H30.6602V104.379H31.88V103.159Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 105.205H30.6602V106.425H31.88V105.205Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 107.248H30.6602V108.467H31.88V107.248Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 109.293H30.6602V110.513H31.88V109.293Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 111.335H30.6602V112.555H31.88V111.335Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 113.383H30.6602V114.603H31.88V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 115.425H30.6602V116.645H31.88V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 117.471H30.6602V118.691H31.88V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 119.513H30.6602V120.733H31.88V119.513Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 121.559H30.6602V122.779H31.88V121.559Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 123.601H30.6602V124.821H31.88V123.601Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 125.648H30.6602V126.868H31.88V125.648Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 127.69H30.6602V128.91H31.88V127.69Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 129.735H30.6602V130.955H31.88V129.735Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 131.778H30.6602V132.998H31.88V131.778Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 133.825H30.6602V135.045H31.88V133.825Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 135.871H30.6602V137.09H31.88V135.871Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 137.913H30.6602V139.132H31.88V137.913Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 103.159H32.5957V104.379H33.8156V103.159Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 105.205H32.5957V106.425H33.8156V105.205Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 107.248H32.5957V108.467H33.8156V107.248Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 109.293H32.5957V110.513H33.8156V109.293Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 111.335H32.5957V112.555H33.8156V111.335Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 113.383H32.5957V114.603H33.8156V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 115.425H32.5957V116.645H33.8156V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 117.471H32.5957V118.691H33.8156V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 119.513H32.5957V120.733H33.8156V119.513Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 121.559H32.5957V122.779H33.8156V121.559Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 123.601H32.5957V124.821H33.8156V123.601Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 125.648H32.5957V126.868H33.8156V125.648Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 127.69H32.5957V128.91H33.8156V127.69Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 129.735H32.5957V130.955H33.8156V129.735Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 131.778H32.5957V132.998H33.8156V131.778Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 133.825H32.5957V135.045H33.8156V133.825Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 135.871H32.5957V137.09H33.8156V135.871Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8156 137.913H32.5957V139.132H33.8156V137.913Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 118.08H21.4805V119.3H22.7003V118.08Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 120.122H21.4805V121.342H22.7003V120.122Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 122.169H21.4805V123.389H22.7003V122.169Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 124.212H21.4805V125.432H22.7003V124.212Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 126.258H21.4805V127.478H22.7003V126.258Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 128.3H21.4805V129.52H22.7003V128.3Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 130.346H21.4805V131.566H22.7003V130.346Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 132.388H21.4805V133.608H22.7003V132.388Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 134.435H21.4805V135.655H22.7003V134.435Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 136.477H21.4805V137.697H22.7003V136.477Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 138.523H21.4805V139.743H22.7003V138.523Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 140.565H21.4805V141.785H22.7003V140.565Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7003 142.611H21.4805V143.831H22.7003V142.611Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 118.08H23.417V119.3H24.6368V118.08Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 120.122H23.417V121.342H24.6368V120.122Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 122.169H23.417V123.389H24.6368V122.169Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 124.212H23.417V125.432H24.6368V124.212Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 126.258H23.417V127.478H24.6368V126.258Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 128.3H23.417V129.52H24.6368V128.3Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 130.346H23.417V131.566H24.6368V130.346Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 132.388H23.417V133.608H24.6368V132.388Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 134.435H23.417V135.655H24.6368V134.435Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 136.477H23.417V137.697H24.6368V136.477Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 138.523H23.417V139.743H24.6368V138.523Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 140.565H23.417V141.785H24.6368V140.565Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6368 142.611H23.417V143.831H24.6368V142.611Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 118.08H25.3525V119.3H26.5724V118.08Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 120.122H25.3525V121.342H26.5724V120.122Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 122.169H25.3525V123.389H26.5724V122.169Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 124.212H25.3525V125.432H26.5724V124.212Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 126.258H25.3525V127.478H26.5724V126.258Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 128.3H25.3525V129.52H26.5724V128.3Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 130.346H25.3525V131.566H26.5724V130.346Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 132.388H25.3525V133.608H26.5724V132.388Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 134.435H25.3525V135.655H26.5724V134.435Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 136.477H25.3525V137.697H26.5724V136.477Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 138.523H25.3525V139.743H26.5724V138.523Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 140.565H25.3525V141.785H26.5724V140.565Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 142.611H25.3525V143.831H26.5724V142.611Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5724 144.657H25.3525V145.877H26.5724V144.657Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 118.691H36.1143V119.911H37.3341V118.691Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 120.733H36.1143V121.953H37.3341V120.733Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 122.779H36.1143V123.999H37.3341V122.779Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 124.821H36.1143V126.041H37.3341V124.821Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 126.867H36.1143V128.087H37.3341V126.867Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 128.909H36.1143V130.129H37.3341V128.909Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 130.957H36.1143V132.176H37.3341V130.957Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 132.999H36.1143V134.218H37.3341V132.999Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 135.044H36.1143V136.264H37.3341V135.044Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 137.086H36.1143V138.306H37.3341V137.086Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3341 143.222H36.1143V144.442H37.3341V143.222Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 118.691H38.0508V119.911H39.2706V118.691Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 120.733H38.0508V121.953H39.2706V120.733Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 122.779H38.0508V123.999H39.2706V122.779Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 124.821H38.0508V126.041H39.2706V124.821Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 126.867H38.0508V128.087H39.2706V126.867Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 128.909H38.0508V130.129H39.2706V128.909Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 130.957H38.0508V132.176H39.2706V130.957Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 132.999H38.0508V134.218H39.2706V132.999Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 135.044H38.0508V136.264H39.2706V135.044Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 141.175H38.0508V142.395H39.2706V141.175Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2706 143.222H38.0508V144.442H39.2706V143.222Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 118.691H39.9863V119.911H41.2062V118.691Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 120.733H39.9863V121.953H41.2062V120.733Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 122.779H39.9863V123.999H41.2062V122.779Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 124.821H39.9863V126.041H41.2062V124.821Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 126.867H39.9863V128.087H41.2062V126.867Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 128.909H39.9863V130.129H41.2062V128.909Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 130.957H39.9863V132.176H41.2062V130.957Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 132.999H39.9863V134.218H41.2062V132.999Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 139.133H39.9863V140.353H41.2062V139.133Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 141.175H39.9863V142.395H41.2062V141.175Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2062 143.222H39.9863V144.442H41.2062V143.222Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 87.6318H57.9893V88.8517H59.2091V87.6318Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 89.6738H57.9893V90.8937H59.2091V89.6738Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 91.7197H57.9893V92.9396H59.2091V91.7197Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 93.7617H57.9893V94.9816H59.2091V93.7617Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 95.8091H57.9893V97.0289H59.2091V95.8091Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 97.8511H57.9893V99.0709H59.2091V97.8511Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 99.897H57.9893V101.117H59.2091V99.897Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 101.939H57.9893V103.159H59.2091V101.939Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 103.985H57.9893V105.205H59.2091V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 106.027H57.9893V107.247H59.2091V106.027Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 108.075H57.9893V109.295H59.2091V108.075Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 110.115H57.9893V111.335H59.2091V110.115Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 112.162H57.9893V113.381H59.2091V112.162Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 114.208H57.9893V115.428H59.2091V114.208Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 116.251H57.9893V117.471H59.2091V116.251Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 118.297H57.9893V119.517H59.2091V118.297Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 120.339H57.9893V121.559H59.2091V120.339Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 124.428H57.9893V125.648H59.2091V124.428Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 126.474H57.9893V127.694H59.2091V126.474Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 128.517H57.9893V129.736H59.2091V128.517Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 130.562H57.9893V131.782H59.2091V130.562Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2091 132.604H57.9893V133.824H59.2091V132.604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 87.6318H59.9248V88.8517H61.1447V87.6318Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 89.6738H59.9248V90.8937H61.1447V89.6738Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 91.7197H59.9248V92.9396H61.1447V91.7197Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 93.7617H59.9248V94.9816H61.1447V93.7617Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 95.8091H59.9248V97.0289H61.1447V95.8091Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 97.8511H59.9248V99.0709H61.1447V97.8511Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 99.897H59.9248V101.117H61.1447V99.897Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 101.939H59.9248V103.159H61.1447V101.939Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 103.985H59.9248V105.205H61.1447V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 106.027H59.9248V107.247H61.1447V106.027Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 108.075H59.9248V109.295H61.1447V108.075Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 110.115H59.9248V111.335H61.1447V110.115Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 112.162H59.9248V113.381H61.1447V112.162Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 114.208H59.9248V115.428H61.1447V114.208Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 116.251H59.9248V117.471H61.1447V116.251Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 118.297H59.9248V119.517H61.1447V118.297Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 130.562H59.9248V131.782H61.1447V130.562Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1447 132.604H59.9248V133.824H61.1447V132.604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 87.6318H61.8652V88.8517H63.0851V87.6318Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 89.6738H61.8652V90.8937H63.0851V89.6738Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 91.7197H61.8652V92.9396H63.0851V91.7197Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 93.7617H61.8652V94.9816H63.0851V93.7617Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 95.8091H61.8652V97.0289H63.0851V95.8091Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 97.8511H61.8652V99.0709H63.0851V97.8511Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 99.897H61.8652V101.117H63.0851V99.897Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 101.939H61.8652V103.159H63.0851V101.939Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 103.985H61.8652V105.205H63.0851V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 106.027H61.8652V107.247H63.0851V106.027Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 108.075H61.8652V109.295H63.0851V108.075Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 110.115H61.8652V111.335H63.0851V110.115Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 112.162H61.8652V113.381H63.0851V112.162Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 114.208H61.8652V115.428H63.0851V114.208Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 116.251H61.8652V117.471H63.0851V116.251Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 118.297H61.8652V119.517H63.0851V118.297Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 122.385H61.8652V123.605H63.0851V122.385Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 124.428H61.8652V125.648H63.0851V124.428Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 126.474H61.8652V127.694H63.0851V126.474Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 128.517H61.8652V129.736H63.0851V128.517Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0851 132.604H61.8652V133.824H63.0851V132.604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 113.383H50.9609V114.603H52.1808V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 115.425H50.9609V116.645H52.1808V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 117.471H50.9609V118.691H52.1808V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 119.513H50.9609V120.733H52.1808V119.513Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 121.559H50.9609V122.779H52.1808V121.559Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 123.601H50.9609V124.821H52.1808V123.601Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 125.648H50.9609V126.868H52.1808V125.648Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 129.735H50.9609V130.955H52.1808V129.735Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 131.778H50.9609V132.998H52.1808V131.778Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 133.825H50.9609V135.045H52.1808V133.825Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 135.871H50.9609V137.09H52.1808V135.871Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 137.913H50.9609V139.132H52.1808V137.913Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 139.958H50.9609V141.178H52.1808V139.958Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 142H50.9609V143.22H52.1808V142Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1808 144.048H50.9609V145.268H52.1808V144.048Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 113.383H52.8975V114.603H54.1173V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 115.425H52.8975V116.645H54.1173V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 117.471H52.8975V118.691H54.1173V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 119.513H52.8975V120.733H54.1173V119.513Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 121.559H52.8975V122.779H54.1173V121.559Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 123.601H52.8975V124.821H54.1173V123.601Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 129.735H52.8975V130.955H54.1173V129.735Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 131.778H52.8975V132.998H54.1173V131.778Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 133.825H52.8975V135.045H54.1173V133.825Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 135.871H52.8975V137.09H54.1173V135.871Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 137.913H52.8975V139.132H54.1173V137.913Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 139.958H52.8975V141.178H54.1173V139.958Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 142H52.8975V143.22H54.1173V142Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1173 144.048H52.8975V145.268H54.1173V144.048Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 113.383H54.833V114.603H56.0529V113.383Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 115.425H54.833V116.645H56.0529V115.425Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 117.471H54.833V118.691H56.0529V117.471Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 119.513H54.833V120.733H56.0529V119.513Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 121.559H54.833V122.779H56.0529V121.559Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 123.601H54.833V124.821H56.0529V123.601Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 127.69H54.833V128.91H56.0529V127.69Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 129.735H54.833V130.955H56.0529V129.735Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 131.778H54.833V132.998H56.0529V131.778Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 133.825H54.833V135.045H56.0529V133.825Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 135.871H54.833V137.09H56.0529V135.871Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 137.913H54.833V139.132H56.0529V137.913Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 139.958H54.833V141.178H56.0529V139.958Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 142H54.833V143.22H56.0529V142Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0529 144.048H54.833V145.268H56.0529V144.048Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 101.939H95.6465V103.159H96.8663V101.939Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 103.985H95.6465V105.205H96.8663V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 106.027H95.6465V107.247H96.8663V106.027Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 108.075H95.6465V109.295H96.8663V108.075Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 110.115H95.6465V111.335H96.8663V110.115Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 112.162H95.6465V113.381H96.8663V112.162Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 114.208H95.6465V115.428H96.8663V114.208Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 116.251H95.6465V117.471H96.8663V116.251Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 118.297H95.6465V119.517H96.8663V118.297Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 120.339H95.6465V121.559H96.8663V120.339Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 122.385H95.6465V123.605H96.8663V122.385Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 124.428H95.6465V125.648H96.8663V124.428Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 126.474H95.6465V127.694H96.8663V126.474Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 130.562H95.6465V131.782H96.8663V130.562Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 132.604H95.6465V133.824H96.8663V132.604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 134.65H95.6465V135.87H96.8663V134.65Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 136.694H95.6465V137.914H96.8663V136.694Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 140.782H95.6465V142.002H96.8663V140.782Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 142.828H95.6465V144.048H96.8663V142.828Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8663 144.87H95.6465V146.09H96.8663V144.87Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 101.939H97.583V103.159H98.8029V101.939Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 103.985H97.583V105.205H98.8029V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 106.027H97.583V107.247H98.8029V106.027Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 108.075H97.583V109.295H98.8029V108.075Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 110.115H97.583V111.335H98.8029V110.115Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 112.162H97.583V113.381H98.8029V112.162Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 114.208H97.583V115.428H98.8029V114.208Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 116.251H97.583V117.471H98.8029V116.251Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 118.297H97.583V119.517H98.8029V118.297Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 120.339H97.583V121.559H98.8029V120.339Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 122.385H97.583V123.605H98.8029V122.385Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 124.428H97.583V125.648H98.8029V124.428Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 126.474H97.583V127.694H98.8029V126.474Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 132.604H97.583V133.824H98.8029V132.604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 134.65H97.583V135.87H98.8029V134.65Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 138.74H97.583V139.96H98.8029V138.74Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 140.782H97.583V142.002H98.8029V140.782Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 142.828H97.583V144.048H98.8029V142.828Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8029 144.87H97.583V146.09H98.8029V144.87Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 101.939H99.5234V103.159H100.743V101.939Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 103.985H99.5234V105.205H100.743V103.985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 106.027H99.5234V107.247H100.743V106.027Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 108.075H99.5234V109.295H100.743V108.075Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 110.115H99.5234V111.335H100.743V110.115Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 112.162H99.5234V113.381H100.743V112.162Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 114.208H99.5234V115.428H100.743V114.208Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 116.251H99.5234V117.471H100.743V116.251Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 118.297H99.5234V119.517H100.743V118.297Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 120.339H99.5234V121.559H100.743V120.339Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 122.385H99.5234V123.605H100.743V122.385Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 124.428H99.5234V125.648H100.743V124.428Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 126.474H99.5234V127.694H100.743V126.474Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 128.517H99.5234V129.736H100.743V128.517Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 132.604H99.5234V133.824H100.743V132.604Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 136.694H99.5234V137.914H100.743V136.694Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 138.74H99.5234V139.96H100.743V138.74Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 140.782H99.5234V142.002H100.743V140.782Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 142.828H99.5234V144.048H100.743V142.828Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.743 144.87H99.5234V146.09H100.743V144.87Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 113.598H87.7568V114.818H88.9767V113.598Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 115.642H87.7568V116.861H88.9767V115.642Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 117.688H87.7568V118.907H88.9767V117.688Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 119.729H87.7568V120.949H88.9767V119.729Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 121.775H87.7568V122.995H88.9767V121.775Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 123.817H87.7568V125.037H88.9767V123.817Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 129.953H87.7568V131.173H88.9767V129.953Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 131.995H87.7568V133.215H88.9767V131.995Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 134.041H87.7568V135.261H88.9767V134.041Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 136.083H87.7568V137.303H88.9767V136.083Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 138.129H87.7568V139.349H88.9767V138.129Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 140.172H87.7568V141.392H88.9767V140.172Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9767 142.217H87.7568V143.437H88.9767V142.217Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 113.598H89.6934V114.818H90.9132V113.598Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 115.642H89.6934V116.861H90.9132V115.642Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 117.688H89.6934V118.907H90.9132V117.688Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 119.729H89.6934V120.949H90.9132V119.729Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 121.775H89.6934V122.995H90.9132V121.775Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 123.817H89.6934V125.037H90.9132V123.817Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 129.953H89.6934V131.173H90.9132V129.953Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 131.995H89.6934V133.215H90.9132V131.995Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 134.041H89.6934V135.261H90.9132V134.041Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 136.083H89.6934V137.303H90.9132V136.083Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 138.129H89.6934V139.349H90.9132V138.129Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 140.172H89.6934V141.392H90.9132V140.172Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9132 144.259H89.6934V145.479H90.9132V144.259Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 104.596H154.035V105.816H155.255V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 106.638H154.035V107.858H155.255V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 108.684H154.035V109.904H155.255V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 110.726H154.035V111.946H155.255V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 112.772H154.035V113.992H155.255V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 114.814H154.035V116.034H155.255V114.814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 116.861H154.035V118.081H155.255V116.861Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 118.903H154.035V120.123H155.255V118.903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 120.948H154.035V122.168H155.255V120.948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 122.996H154.035V124.215H155.255V122.996Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 125.038H154.035V126.257H155.255V125.038Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 129.126H154.035V130.346H155.255V129.126Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 131.172H154.035V132.392H155.255V131.172Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 133.214H154.035V134.434H155.255V133.214Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 135.261H154.035V136.481H155.255V135.261Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 137.303H154.035V138.523H155.255V137.303Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 139.349H154.035V140.569H155.255V139.349Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 141.391H154.035V142.611H155.255V141.391Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.255 143.438H154.035V144.657H155.255V143.438Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 104.596H155.971V105.816H157.191V104.596Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 106.638H155.971V107.858H157.191V106.638Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 108.684H155.971V109.904H157.191V108.684Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 110.726H155.971V111.946H157.191V110.726Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 112.772H155.971V113.992H157.191V112.772Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 114.814H155.971V116.034H157.191V114.814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 116.861H155.971V118.081H157.191V116.861Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 118.903H155.971V120.123H157.191V118.903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 120.948H155.971V122.168H157.191V120.948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 122.996H155.971V124.215H157.191V122.996Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 125.038H155.971V126.257H157.191V125.038Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 127.083H155.971V128.303H157.191V127.083Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 129.126H155.971V130.346H157.191V129.126Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 131.172H155.971V132.392H157.191V131.172Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 133.214H155.971V134.434H157.191V133.214Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 135.261H155.971V136.481H157.191V135.261Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 137.303H155.971V138.523H157.191V137.303Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 139.349H155.971V140.569H157.191V139.349Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 141.391H155.971V142.611H157.191V141.391Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.191 143.438H155.971V144.657H157.191V143.438Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 112.556H144.496V113.776H145.716V112.556Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 114.602H144.496V115.821H145.716V114.602Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 116.644H144.496V117.863H145.716V116.644Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 118.691H144.496V119.911H145.716V118.691Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 120.733H144.496V121.953H145.716V120.733Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 122.779H144.496V123.999H145.716V122.779Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 124.821H144.496V126.041H145.716V124.821Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 126.867H144.496V128.087H145.716V126.867Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 128.909H144.496V130.129H145.716V128.909Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.716 130.957H144.496V132.176H145.716V130.957Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.652 112.556H146.433V113.776H147.652V112.556Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.652 114.602H146.433V115.821H147.652V114.602Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.652 116.644H146.433V117.863H147.652V116.644Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.652 118.691H146.433V119.911H147.652V118.691Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.652 120.733H146.433V121.953H147.652V120.733Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.652 122.779H146.433V123.999H147.652V122.779Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.652 124.821H146.433V126.041H147.652V124.821Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.652 126.867H146.433V128.087H147.652V126.867Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.652 128.909H146.433V130.129H147.652V128.909Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.44 44.5356C130.44 44.0802 130.529 43.6292 130.703 43.2083C130.877 42.7875 131.133 42.4051 131.455 42.0831C131.777 41.7611 132.159 41.5057 132.58 41.3317C133.001 41.1577 133.452 41.0684 133.907 41.0689C134.246 41.069 134.582 41.118 134.907 41.2145C134.753 40.1704 134.826 39.1054 135.121 38.0921C135.416 37.0788 135.926 36.1409 136.616 35.3425C137.306 34.5441 138.16 33.9038 139.12 33.4653C140.08 33.0268 141.123 32.8003 142.179 32.8014C142.633 32.8034 143.086 32.8455 143.532 32.9274C144.256 31.7372 145.348 30.8149 146.642 30.2995C147.937 29.784 149.363 29.7034 150.707 30.0699C152.052 30.4363 153.24 31.2299 154.094 32.331C154.947 33.432 155.42 34.7807 155.439 36.1737H155.558C157.127 36.1737 158.631 36.7971 159.741 37.9066C160.85 39.0161 161.474 40.5209 161.474 42.09C161.474 43.6591 160.85 45.1639 159.741 46.2734C158.631 47.383 157.127 48.0063 155.558 48.0063H133.813C132.909 47.9817 132.051 47.605 131.421 46.9567C130.791 46.3084 130.439 45.4396 130.44 44.5356Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2276 45.7908C22.2276 45.2033 22.461 44.6398 22.8765 44.2243C23.2919 43.8088 23.8554 43.5754 24.443 43.5754C24.6576 43.5764 24.8709 43.6082 25.0765 43.6699C25.0449 43.4443 25.0291 43.2169 25.0293 42.9891C25.0293 41.7451 25.5235 40.5521 26.4031 39.6724C27.2828 38.7928 28.4758 38.2986 29.7198 38.2986C30.0091 38.298 30.2977 38.3257 30.5816 38.3812C31.0439 37.6216 31.7405 37.0329 32.5666 36.7038C33.3927 36.3747 34.3033 36.323 35.1613 36.5566C36.0193 36.7902 36.7781 37.2964 37.3233 37.9988C37.8685 38.7013 38.1706 39.5619 38.184 40.451H38.2548C39.2361 40.4827 40.1666 40.8948 40.8496 41.6001C41.5325 42.3055 41.9144 43.2488 41.9144 44.2306C41.9144 45.2124 41.5325 46.1557 40.8496 46.8611C40.1666 47.5664 39.2361 47.9785 38.2548 48.0102H24.38C23.8021 47.9958 23.2529 47.7552 22.8504 47.3402C22.4479 46.9252 22.2243 46.3689 22.2276 45.7908Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.959 67.8971C86.959 67.537 87.102 67.1917 87.3566 66.9371C87.6112 66.6825 87.9565 66.5395 88.3166 66.5395C88.4498 66.5408 88.5823 66.5607 88.7101 66.5985C88.6896 66.4604 88.6791 66.321 88.6786 66.1814C88.6786 65.4196 88.9812 64.6889 89.5199 64.1502C90.0586 63.6115 90.7893 63.3089 91.5511 63.3089C91.7293 63.3086 91.9071 63.3244 92.0824 63.3561C92.3655 62.8906 92.7924 62.5299 93.2986 62.3284C93.8048 62.1269 94.3628 62.0955 94.8884 62.239C95.414 62.3825 95.8786 62.6931 96.2122 63.1239C96.5458 63.5547 96.7301 64.0823 96.7375 64.6271H96.7807C97.3784 64.6517 97.9434 64.9065 98.3576 65.3381C98.7717 65.7697 99.003 66.3447 99.003 66.9428C99.003 67.541 98.7717 68.116 98.3576 68.5476C97.9434 68.9792 97.3784 69.2339 96.7807 69.2586H88.2693C87.9172 69.2453 87.5839 69.0961 87.3395 68.8422C87.0951 68.5883 86.9587 68.2495 86.959 67.8971Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4998 168.245C140.637 168.245 174.796 166.25 174.796 163.79C174.796 161.33 140.637 159.336 98.4998 159.336C56.3629 159.336 22.2041 161.33 22.2041 163.79C22.2041 166.25 56.3629 168.245 98.4998 168.245Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57 71.9873H66.6387V147.04H124.57V71.9873Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M124.57 71.9873H66.6387V147.04H124.57V71.9873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.627 71.8818H68.9014V142.318H89.627V71.8818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.307 71.8818H101.581V142.318H122.307V71.8818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.265 77.6021H115.404V81.4623H119.265V77.6021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.266 77.9009H115.708V81.1591H117.266V77.9009Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.962 77.9048H117.403V81.163H118.962V77.9048Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.265 77.9014H115.707V81.1595H117.265V77.9014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.961 77.9053H117.402V81.1635H118.961V77.9053Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.145 81.856H114.035V83.4929H114.145V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.735 81.856H114.625V83.4929H114.735V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.326 81.856H115.216V83.4929H115.326V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.917 81.856H115.807V83.4929H115.917V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.507 81.856H116.396V83.4929H116.507V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.097 81.856H116.986V83.4929H117.097V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.687 81.856H117.577V83.4929H117.687V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.277 81.856H118.167V83.4929H118.277V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.867 81.856H118.757V83.4929H118.867V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.458 81.856H119.348V83.4929H119.458V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.048 81.856H119.938V83.4929H120.048V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.638 81.856H120.527V83.4929H120.638V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 81.7583H113.949V81.9551H120.721V81.7583Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 83.332H113.949V83.5288H120.721V83.332Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.265 87.6367H115.404V91.497H119.265V87.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.266 87.9355H115.708V91.1937H117.266V87.9355Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.962 87.9395H117.403V91.1976H118.962V87.9395Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.265 87.9346H115.707V91.1927H117.265V87.9346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.961 87.9385H117.402V91.1967H118.961V87.9385Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.145 91.8901H114.035V93.5271H114.145V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.735 91.8901H114.625V93.5271H114.735V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.326 91.8901H115.216V93.5271H115.326V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.917 91.8901H115.807V93.5271H115.917V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.507 91.8901H116.396V93.5271H116.507V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.097 91.8901H116.986V93.5271H117.097V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.687 91.8901H117.577V93.5271H117.687V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.277 91.8901H118.167V93.5271H118.277V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.867 91.8901H118.757V93.5271H118.867V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.458 91.8901H119.348V93.5271H119.458V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.048 91.8901H119.938V93.5271H120.048V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.638 91.8901H120.527V93.5271H120.638V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 91.7925H113.949V91.9892H120.721V91.7925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 93.3662H113.949V93.563H120.721V93.3662Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.265 97.6709H115.404V101.531H119.265V97.6709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.266 97.9697H115.708V101.228H117.266V97.9697Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.962 97.9736H117.403V101.232H118.962V97.9736Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.265 97.9702H115.707V101.228H117.265V97.9702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.961 97.9741H117.402V101.232H118.961V97.9741Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.145 101.925H114.035V103.562H114.145V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.735 101.925H114.625V103.562H114.735V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.326 101.925H115.216V103.562H115.326V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.917 101.925H115.807V103.562H115.917V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.507 101.925H116.396V103.562H116.507V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.097 101.925H116.986V103.562H117.097V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.687 101.925H117.577V103.562H117.687V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.277 101.925H118.167V103.562H118.277V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.867 101.925H118.757V103.562H118.867V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.458 101.925H119.348V103.562H119.458V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.048 101.925H119.938V103.562H120.048V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.638 101.925H120.527V103.562H120.638V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 101.827H113.949V102.023H120.721V101.827Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 103.4H113.949V103.597H120.721V103.4Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.265 107.705H115.404V111.565H119.265V107.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.266 108.004H115.708V111.262H117.266V108.004Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.962 108.008H117.403V111.266H118.962V108.008Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.265 108.003H115.707V111.262H117.265V108.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.961 108.007H117.402V111.266H118.961V108.007Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.145 111.959H114.035V113.596H114.145V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.735 111.959H114.625V113.596H114.735V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.326 111.959H115.216V113.596H115.326V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.917 111.959H115.807V113.596H115.917V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.507 111.959H116.396V113.596H116.507V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.097 111.959H116.986V113.596H117.097V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.687 111.959H117.577V113.596H117.687V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.277 111.959H118.167V113.596H118.277V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.867 111.959H118.757V113.596H118.867V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.458 111.959H119.348V113.596H119.458V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.048 111.959H119.938V113.596H120.048V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.638 111.959H120.527V113.596H120.638V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 111.861H113.949V112.058H120.721V111.861Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 113.435H113.949V113.631H120.721V113.435Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.265 117.739H115.404V121.599H119.265V117.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.266 118.038H115.708V121.296H117.266V118.038Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.962 118.042H117.403V121.3H118.962V118.042Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.265 118.039H115.707V121.297H117.265V118.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.961 118.042H117.402V121.301H118.961V118.042Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.145 121.993H114.035V123.63H114.145V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.735 121.993H114.625V123.63H114.735V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.326 121.993H115.216V123.63H115.326V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.917 121.993H115.807V123.63H115.917V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.507 121.993H116.396V123.63H116.507V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.097 121.993H116.986V123.63H117.097V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.687 121.993H117.577V123.63H117.687V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.277 121.993H118.167V123.63H118.277V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.867 121.993H118.757V123.63H118.867V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.458 121.993H119.348V123.63H119.458V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.048 121.993H119.938V123.63H120.048V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.638 121.993H120.527V123.63H120.638V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 121.896H113.949V122.092H120.721V121.896Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 123.469H113.949V123.666H120.721V123.469Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.265 127.773H115.404V131.634H119.265V127.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.266 128.072H115.708V131.33H117.266V128.072Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.962 128.076H117.403V131.334H118.962V128.076Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.265 128.072H115.707V131.33H117.265V128.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.961 128.076H117.402V131.334H118.961V128.076Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.145 132.027H114.035V133.664H114.145V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.735 132.027H114.625V133.664H114.735V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.326 132.027H115.216V133.664H115.326V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.917 132.027H115.807V133.664H115.917V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.507 132.027H116.396V133.664H116.507V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.097 132.027H116.986V133.664H117.097V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.687 132.027H117.577V133.664H117.687V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.277 132.027H118.167V133.664H118.277V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.867 132.027H118.757V133.664H118.867V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.458 132.027H119.348V133.664H119.458V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.048 132.027H119.938V133.664H120.048V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.638 132.027H120.527V133.664H120.638V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 131.93H113.949V132.126H120.721V131.93Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 133.503H113.949V133.7H120.721V133.503Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.4 77.6021H104.54V81.4623H108.4V77.6021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.397 77.9009H104.839V81.1591H106.397V77.9009Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 77.9048H106.539V81.163H108.097V77.9048Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.397 77.9014H104.839V81.1595H106.397V77.9014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 77.9053H106.539V81.1635H108.097V77.9053Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.277 81.856H103.167V83.4929H103.277V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.867 81.856H103.757V83.4929H103.867V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.457 81.856H104.347V83.4929H104.457V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.048 81.856H104.938V83.4929H105.048V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.638 81.856H105.528V83.4929H105.638V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.228 81.856H106.118V83.4929H106.228V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.818 81.856H106.708V83.4929H106.818V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.409 81.856H107.299V83.4929H107.409V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.999 81.856H107.889V83.4929H107.999V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.589 81.856H108.479V83.4929H108.589V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.18 81.856H109.069V83.4929H109.18V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.769 81.856H109.659V83.4929H109.769V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 81.7583H103.084V81.9551H109.856V81.7583Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 83.332H103.084V83.5288H109.856V83.332Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.4 87.6367H104.54V91.497H108.4V87.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.397 87.9355H104.839V91.1937H106.397V87.9355Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 87.9395H106.539V91.1976H108.097V87.9395Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.397 87.9346H104.839V91.1927H106.397V87.9346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 87.9385H106.539V91.1967H108.097V87.9385Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.277 91.8901H103.167V93.5271H103.277V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.867 91.8901H103.757V93.5271H103.867V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.457 91.8901H104.347V93.5271H104.457V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.048 91.8901H104.938V93.5271H105.048V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.638 91.8901H105.528V93.5271H105.638V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.228 91.8901H106.118V93.5271H106.228V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.818 91.8901H106.708V93.5271H106.818V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.409 91.8901H107.299V93.5271H107.409V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.999 91.8901H107.889V93.5271H107.999V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.589 91.8901H108.479V93.5271H108.589V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.18 91.8901H109.069V93.5271H109.18V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.769 91.8901H109.659V93.5271H109.769V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 91.7925H103.084V91.9892H109.856V91.7925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 93.3662H103.084V93.563H109.856V93.3662Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.4 97.6709H104.54V101.531H108.4V97.6709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.397 97.9697H104.839V101.228H106.397V97.9697Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 97.9736H106.539V101.232H108.097V97.9736Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.397 97.9697H104.839V101.228H106.397V97.9697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 97.9736H106.539V101.232H108.097V97.9736Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.277 101.925H103.167V103.562H103.277V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.867 101.925H103.757V103.562H103.867V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.457 101.925H104.347V103.562H104.457V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.048 101.925H104.938V103.562H105.048V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.638 101.925H105.528V103.562H105.638V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.228 101.925H106.118V103.562H106.228V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.818 101.925H106.708V103.562H106.818V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.409 101.925H107.299V103.562H107.409V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.999 101.925H107.889V103.562H107.999V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.589 101.925H108.479V103.562H108.589V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.18 101.925H109.069V103.562H109.18V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.769 101.925H109.659V103.562H109.769V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 101.827H103.084V102.023H109.856V101.827Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 103.4H103.084V103.597H109.856V103.4Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.4 107.705H104.54V111.565H108.4V107.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.397 108.004H104.839V111.262H106.397V108.004Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 108.008H106.539V111.266H108.097V108.008Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.397 108.003H104.839V111.262H106.397V108.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 108.007H106.539V111.266H108.097V108.007Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.277 111.959H103.167V113.596H103.277V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.867 111.959H103.757V113.596H103.867V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.457 111.959H104.347V113.596H104.457V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.048 111.959H104.938V113.596H105.048V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.638 111.959H105.528V113.596H105.638V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.228 111.959H106.118V113.596H106.228V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.818 111.959H106.708V113.596H106.818V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.409 111.959H107.299V113.596H107.409V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.999 111.959H107.889V113.596H107.999V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.589 111.959H108.479V113.596H108.589V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.18 111.959H109.069V113.596H109.18V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.769 111.959H109.659V113.596H109.769V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 111.861H103.084V112.058H109.856V111.861Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 113.435H103.084V113.631H109.856V113.435Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.4 117.739H104.54V121.599H108.4V117.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.397 118.038H104.839V121.296H106.397V118.038Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 118.042H106.539V121.3H108.097V118.042Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.397 118.039H104.839V121.297H106.397V118.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 118.043H106.539V121.301H108.097V118.043Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.277 121.993H103.167V123.63H103.277V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.867 121.993H103.757V123.63H103.867V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.457 121.993H104.347V123.63H104.457V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.048 121.993H104.938V123.63H105.048V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.638 121.993H105.528V123.63H105.638V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.228 121.993H106.118V123.63H106.228V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.818 121.993H106.708V123.63H106.818V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.409 121.993H107.299V123.63H107.409V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.999 121.993H107.889V123.63H107.999V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.589 121.993H108.479V123.63H108.589V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.18 121.993H109.069V123.63H109.18V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.769 121.993H109.659V123.63H109.769V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 121.896H103.084V122.092H109.856V121.896Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 123.469H103.084V123.666H109.856V123.469Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.4 127.773H104.54V131.634H108.4V127.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.397 128.072H104.839V131.33H106.397V128.072Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 128.076H106.539V131.334H108.097V128.076Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.397 128.072H104.839V131.33H106.397V128.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.097 128.076H106.539V131.334H108.097V128.076Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.277 132.027H103.167V133.664H103.277V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.867 132.027H103.757V133.664H103.867V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.457 132.027H104.347V133.664H104.457V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.048 132.027H104.938V133.664H105.048V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.638 132.027H105.528V133.664H105.638V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.228 132.027H106.118V133.664H106.228V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.818 132.027H106.708V133.664H106.818V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.409 132.027H107.299V133.664H107.409V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.999 132.027H107.889V133.664H107.999V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.589 132.027H108.479V133.664H108.589V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.18 132.027H109.069V133.664H109.18V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.769 132.027H109.659V133.664H109.769V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 131.93H103.084V132.126H109.856V131.93Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.856 133.503H103.084V133.7H109.856V133.503Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M97.536 77.6021H93.6758V81.4623H97.536V77.6021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5329 77.9009H93.9746V81.1591H95.5329V77.9009Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2331 77.9048H95.6748V81.163H97.2331V77.9048Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5319 77.9014H93.9736V81.1595H95.5319V77.9014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2321 77.9053H95.6738V81.1635H97.2321V77.9053Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.4119 81.856H92.3018V83.4929H92.4119V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0028 81.856H92.8926V83.4929H93.0028V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5926 81.856H93.4824V83.4929H93.5926V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1824 81.856H94.0723V83.4929H94.1824V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7733 81.856H94.6631V83.4929H94.7733V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3631 81.856H95.2529V83.4929H95.3631V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9539 81.856H95.8438V83.4929H95.9539V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5438 81.856H96.4336V83.4929H96.5438V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1346 81.856H97.0244V83.4929H97.1346V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7244 81.856H97.6143V83.4929H97.7244V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3143 81.856H98.2041V83.4929H98.3143V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9051 81.856H98.7949V83.4929H98.9051V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 81.7583H92.2188V81.9551H98.9909V81.7583Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 83.332H92.2188V83.5288H98.9909V83.332Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M97.536 87.6367H93.6758V91.497H97.536V87.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5329 87.9355H93.9746V91.1937H95.5329V87.9355Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2331 87.9395H95.6748V91.1976H97.2331V87.9395Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5319 87.9346H93.9736V91.1927H95.5319V87.9346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2321 87.9385H95.6738V91.1967H97.2321V87.9385Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.4119 91.8901H92.3018V93.5271H92.4119V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0028 91.8901H92.8926V93.5271H93.0028V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5926 91.8901H93.4824V93.5271H93.5926V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1824 91.8901H94.0723V93.5271H94.1824V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7733 91.8901H94.6631V93.5271H94.7733V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3631 91.8901H95.2529V93.5271H95.3631V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9539 91.8901H95.8438V93.5271H95.9539V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5438 91.8901H96.4336V93.5271H96.5438V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1346 91.8901H97.0244V93.5271H97.1346V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7244 91.8901H97.6143V93.5271H97.7244V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3143 91.8901H98.2041V93.5271H98.3143V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9051 91.8901H98.7949V93.5271H98.9051V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 91.7925H92.2188V91.9892H98.9909V91.7925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 93.3662H92.2188V93.563H98.9909V93.3662Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M97.536 97.6709H93.6758V101.531H97.536V97.6709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5329 97.9697H93.9746V101.228H95.5329V97.9697Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2331 97.9736H95.6748V101.232H97.2331V97.9736Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5319 97.9702H93.9736V101.228H95.5319V97.9702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2321 97.9741H95.6738V101.232H97.2321V97.9741Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.4119 101.925H92.3018V103.562H92.4119V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0028 101.925H92.8926V103.562H93.0028V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5926 101.925H93.4824V103.562H93.5926V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1824 101.925H94.0723V103.562H94.1824V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7733 101.925H94.6631V103.562H94.7733V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3631 101.925H95.2529V103.562H95.3631V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9539 101.925H95.8438V103.562H95.9539V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5438 101.925H96.4336V103.562H96.5438V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1346 101.925H97.0244V103.562H97.1346V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7244 101.925H97.6143V103.562H97.7244V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3143 101.925H98.2041V103.562H98.3143V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9051 101.925H98.7949V103.562H98.9051V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 101.827H92.2188V102.023H98.9909V101.827Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 103.4H92.2188V103.597H98.9909V103.4Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M97.536 107.705H93.6758V111.565H97.536V107.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5329 108.004H93.9746V111.262H95.5329V108.004Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2331 108.008H95.6748V111.266H97.2331V108.008Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5319 108.003H93.9736V111.262H95.5319V108.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2321 108.007H95.6738V111.266H97.2321V108.007Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.4119 111.959H92.3018V113.596H92.4119V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0028 111.959H92.8926V113.596H93.0028V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5926 111.959H93.4824V113.596H93.5926V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1824 111.959H94.0723V113.596H94.1824V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7733 111.959H94.6631V113.596H94.7733V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3631 111.959H95.2529V113.596H95.3631V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9539 111.959H95.8438V113.596H95.9539V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5438 111.959H96.4336V113.596H96.5438V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1346 111.959H97.0244V113.596H97.1346V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7244 111.959H97.6143V113.596H97.7244V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3143 111.959H98.2041V113.596H98.3143V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9051 111.959H98.7949V113.596H98.9051V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 111.861H92.2188V112.058H98.9909V111.861Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 113.435H92.2188V113.631H98.9909V113.435Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M97.536 117.739H93.6758V121.599H97.536V117.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5329 118.038H93.9746V121.296H95.5329V118.038Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2331 118.042H95.6748V121.3H97.2331V118.042Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5319 118.039H93.9736V121.297H95.5319V118.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2321 118.042H95.6738V121.301H97.2321V118.042Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.4119 121.993H92.3018V123.63H92.4119V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0028 121.993H92.8926V123.63H93.0028V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5926 121.993H93.4824V123.63H93.5926V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1824 121.993H94.0723V123.63H94.1824V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7733 121.993H94.6631V123.63H94.7733V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3631 121.993H95.2529V123.63H95.3631V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9539 121.993H95.8438V123.63H95.9539V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5438 121.993H96.4336V123.63H96.5438V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1346 121.993H97.0244V123.63H97.1346V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7244 121.993H97.6143V123.63H97.7244V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3143 121.993H98.2041V123.63H98.3143V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9051 121.993H98.7949V123.63H98.9051V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 121.896H92.2188V122.092H98.9909V121.896Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 123.469H92.2188V123.666H98.9909V123.469Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M97.536 127.773H93.6758V131.634H97.536V127.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5329 128.072H93.9746V131.33H95.5329V128.072Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2331 128.076H95.6748V131.334H97.2331V128.076Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5319 128.072H93.9736V131.33H95.5319V128.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2321 128.076H95.6738V131.334H97.2321V128.076Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.4119 132.027H92.3018V133.664H92.4119V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0028 132.027H92.8926V133.664H93.0028V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5926 132.027H93.4824V133.664H93.5926V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1824 132.027H94.0723V133.664H94.1824V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7733 132.027H94.6631V133.664H94.7733V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3631 132.027H95.2529V133.664H95.3631V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9539 132.027H95.8438V133.664H95.9539V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5438 132.027H96.4336V133.664H96.5438V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1346 132.027H97.0244V133.664H97.1346V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7244 132.027H97.6143V133.664H97.7244V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3143 132.027H98.2041V133.664H98.3143V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9051 132.027H98.7949V133.664H98.9051V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 131.93H92.2188V132.126H98.9909V131.93Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9909 133.503H92.2188V133.7H98.9909V133.503Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M86.6708 77.6021H82.8105V81.4623H86.6708V77.6021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6686 77.9009H83.1104V81.1591H84.6686V77.9009Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3639 77.9048H84.8057V81.163H86.3639V77.9048Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6676 77.9014H83.1094V81.1595H84.6676V77.9014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.363 77.9053H84.8047V81.1635H86.363V77.9053Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.5477 81.856H81.4375V83.4929H81.5477V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1375 81.856H82.0273V83.4929H82.1375V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7283 81.856H82.6182V83.4929H82.7283V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3192 81.856H83.209V83.4929H83.3192V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.909 81.856H83.7988V83.4929H83.909V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4989 81.856H84.3887V83.4929H84.4989V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0897 81.856H84.9795V83.4929H85.0897V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6795 81.856H85.5693V83.4929H85.6795V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2694 81.856H86.1592V83.4929H86.2694V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8602 81.856H86.75V83.4929H86.8602V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.451 81.856H87.3408V83.4929H87.451V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0399 81.856H87.9297V83.4929H88.0399V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 81.7583H81.3516V81.9551H88.1237V81.7583Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 83.332H81.3516V83.5288H88.1237V83.332Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M86.6708 87.6367H82.8105V91.497H86.6708V87.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6686 87.9355H83.1104V91.1937H84.6686V87.9355Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3639 87.9395H84.8057V91.1976H86.3639V87.9395Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6676 87.9346H83.1094V91.1927H84.6676V87.9346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.363 87.9385H84.8047V91.1967H86.363V87.9385Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.5477 91.8901H81.4375V93.5271H81.5477V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1375 91.8901H82.0273V93.5271H82.1375V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7283 91.8901H82.6182V93.5271H82.7283V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3192 91.8901H83.209V93.5271H83.3192V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.909 91.8901H83.7988V93.5271H83.909V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4989 91.8901H84.3887V93.5271H84.4989V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0897 91.8901H84.9795V93.5271H85.0897V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6795 91.8901H85.5693V93.5271H85.6795V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2694 91.8901H86.1592V93.5271H86.2694V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8602 91.8901H86.75V93.5271H86.8602V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.451 91.8901H87.3408V93.5271H87.451V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0399 91.8901H87.9297V93.5271H88.0399V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 91.7925H81.3516V91.9892H88.1237V91.7925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 93.3662H81.3516V93.563H88.1237V93.3662Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M86.6708 97.6709H82.8105V101.531H86.6708V97.6709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6686 97.9697H83.1104V101.228H84.6686V97.9697Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3639 97.9736H84.8057V101.232H86.3639V97.9736Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6676 97.9702H83.1094V101.228H84.6676V97.9702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.363 97.9741H84.8047V101.232H86.363V97.9741Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.5477 101.925H81.4375V103.562H81.5477V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1375 101.925H82.0273V103.562H82.1375V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7283 101.925H82.6182V103.562H82.7283V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3192 101.925H83.209V103.562H83.3192V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.909 101.925H83.7988V103.562H83.909V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4989 101.925H84.3887V103.562H84.4989V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0897 101.925H84.9795V103.562H85.0897V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6795 101.925H85.5693V103.562H85.6795V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2694 101.925H86.1592V103.562H86.2694V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8602 101.925H86.75V103.562H86.8602V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.451 101.925H87.3408V103.562H87.451V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0399 101.925H87.9297V103.562H88.0399V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 101.827H81.3516V102.023H88.1237V101.827Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 103.4H81.3516V103.597H88.1237V103.4Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M86.6708 107.705H82.8105V111.565H86.6708V107.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6686 108.004H83.1104V111.262H84.6686V108.004Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3639 108.008H84.8057V111.266H86.3639V108.008Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6676 108.003H83.1094V111.262H84.6676V108.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.363 108.007H84.8047V111.266H86.363V108.007Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.5477 111.959H81.4375V113.596H81.5477V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1375 111.959H82.0273V113.596H82.1375V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7283 111.959H82.6182V113.596H82.7283V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3192 111.959H83.209V113.596H83.3192V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.909 111.959H83.7988V113.596H83.909V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4989 111.959H84.3887V113.596H84.4989V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0897 111.959H84.9795V113.596H85.0897V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6795 111.959H85.5693V113.596H85.6795V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2694 111.959H86.1592V113.596H86.2694V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8602 111.959H86.75V113.596H86.8602V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.451 111.959H87.3408V113.596H87.451V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0399 111.959H87.9297V113.596H88.0399V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 111.861H81.3516V112.058H88.1237V111.861Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 113.435H81.3516V113.631H88.1237V113.435Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M86.6708 117.739H82.8105V121.599H86.6708V117.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6686 118.038H83.1104V121.296H84.6686V118.038Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3639 118.042H84.8057V121.3H86.3639V118.042Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6676 118.039H83.1094V121.297H84.6676V118.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.363 118.042H84.8047V121.301H86.363V118.042Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.5477 121.993H81.4375V123.63H81.5477V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1375 121.993H82.0273V123.63H82.1375V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7283 121.993H82.6182V123.63H82.7283V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3192 121.993H83.209V123.63H83.3192V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.909 121.993H83.7988V123.63H83.909V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4989 121.993H84.3887V123.63H84.4989V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0897 121.993H84.9795V123.63H85.0897V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6795 121.993H85.5693V123.63H85.6795V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2694 121.993H86.1592V123.63H86.2694V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8602 121.993H86.75V123.63H86.8602V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.451 121.993H87.3408V123.63H87.451V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0399 121.993H87.9297V123.63H88.0399V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 121.896H81.3516V122.092H88.1237V121.896Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 123.469H81.3516V123.666H88.1237V123.469Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M86.6708 127.773H82.8105V131.634H86.6708V127.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6686 128.072H83.1104V131.33H84.6686V128.072Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3639 128.076H84.8057V131.334H86.3639V128.076Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6676 128.072H83.1094V131.33H84.6676V128.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.363 128.076H84.8047V131.334H86.363V128.076Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.5477 132.027H81.4375V133.664H81.5477V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1375 132.027H82.0273V133.664H82.1375V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7283 132.027H82.6182V133.664H82.7283V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3192 132.027H83.209V133.664H83.3192V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.909 132.027H83.7988V133.664H83.909V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4989 132.027H84.3887V133.664H84.4989V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0897 132.027H84.9795V133.664H85.0897V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6795 132.027H85.5693V133.664H85.6795V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2694 132.027H86.1592V133.664H86.2694V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8602 132.027H86.75V133.664H86.8602V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.451 132.027H87.3408V133.664H87.451V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0399 132.027H87.9297V133.664H88.0399V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 131.93H81.3516V132.126H88.1237V131.93Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1237 133.503H81.3516V133.7H88.1237V133.503Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.8026 77.6021H71.9424V81.4623H75.8026V77.6021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 77.9009H72.2451V81.1591H73.8034V77.9009Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4997 77.9048H73.9414V81.163H75.4997V77.9048Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 77.9014H72.2451V81.1595H73.8034V77.9014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4987 77.9053H73.9404V81.1635H75.4987V77.9053Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.6795 81.856H70.5693V83.4929H70.6795V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2694 81.856H71.1592V83.4929H71.2694V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8592 81.856H71.749V83.4929H71.8592V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.45 81.856H72.3398V83.4929H72.45V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0408 81.856H72.9307V83.4929H73.0408V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6307 81.856H73.5205V83.4929H73.6307V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2205 81.856H74.1104V83.4929H74.2205V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8114 81.856H74.7012V83.4929H74.8114V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4012 81.856H75.291V83.4929H75.4012V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.991 81.856H75.8809V83.4929H75.991V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5819 81.856H76.4717V83.4929H76.5819V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1727 81.856H77.0625V83.4929H77.1727V81.856Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 81.7583H70.4863V81.9551H77.2585V81.7583Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 83.332H70.4863V83.5288H77.2585V83.332Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.8026 87.6367H71.9424V91.497H75.8026V87.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 87.9355H72.2451V91.1937H73.8034V87.9355Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4997 87.9395H73.9414V91.1976H75.4997V87.9395Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 87.9346H72.2451V91.1927H73.8034V87.9346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4987 87.9385H73.9404V91.1967H75.4987V87.9385Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.6795 91.8901H70.5693V93.5271H70.6795V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2694 91.8901H71.1592V93.5271H71.2694V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8592 91.8901H71.749V93.5271H71.8592V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.45 91.8901H72.3398V93.5271H72.45V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0408 91.8901H72.9307V93.5271H73.0408V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6307 91.8901H73.5205V93.5271H73.6307V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2205 91.8901H74.1104V93.5271H74.2205V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8114 91.8901H74.7012V93.5271H74.8114V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4012 91.8901H75.291V93.5271H75.4012V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.991 91.8901H75.8809V93.5271H75.991V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5819 91.8901H76.4717V93.5271H76.5819V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1727 91.8901H77.0625V93.5271H77.1727V91.8901Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 91.7925H70.4863V91.9892H77.2585V91.7925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 93.3662H70.4863V93.563H77.2585V93.3662Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.8026 97.6709H71.9424V101.531H75.8026V97.6709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 97.9697H72.2451V101.228H73.8034V97.9697Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4997 97.9736H73.9414V101.232H75.4997V97.9736Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 97.9697H72.2451V101.228H73.8034V97.9697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4987 97.9736H73.9404V101.232H75.4987V97.9736Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.6795 101.925H70.5693V103.562H70.6795V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2694 101.925H71.1592V103.562H71.2694V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8592 101.925H71.749V103.562H71.8592V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.45 101.925H72.3398V103.562H72.45V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0408 101.925H72.9307V103.562H73.0408V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6307 101.925H73.5205V103.562H73.6307V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2205 101.925H74.1104V103.562H74.2205V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8114 101.925H74.7012V103.562H74.8114V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4012 101.925H75.291V103.562H75.4012V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.991 101.925H75.8809V103.562H75.991V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5819 101.925H76.4717V103.562H76.5819V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1727 101.925H77.0625V103.562H77.1727V101.925Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 101.827H70.4863V102.023H77.2585V101.827Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 103.4H70.4863V103.597H77.2585V103.4Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.8026 107.705H71.9424V111.565H75.8026V107.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 108.004H72.2451V111.262H73.8034V108.004Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4997 108.008H73.9414V111.266H75.4997V108.008Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 108.003H72.2451V111.262H73.8034V108.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4987 108.007H73.9404V111.266H75.4987V108.007Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.6795 111.959H70.5693V113.596H70.6795V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2694 111.959H71.1592V113.596H71.2694V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8592 111.959H71.749V113.596H71.8592V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.45 111.959H72.3398V113.596H72.45V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0408 111.959H72.9307V113.596H73.0408V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6307 111.959H73.5205V113.596H73.6307V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2205 111.959H74.1104V113.596H74.2205V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8114 111.959H74.7012V113.596H74.8114V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4012 111.959H75.291V113.596H75.4012V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.991 111.959H75.8809V113.596H75.991V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5819 111.959H76.4717V113.596H76.5819V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1727 111.959H77.0625V113.596H77.1727V111.959Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 111.861H70.4863V112.058H77.2585V111.861Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 113.435H70.4863V113.631H77.2585V113.435Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.8026 117.739H71.9424V121.599H75.8026V117.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 118.038H72.2451V121.296H73.8034V118.038Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4997 118.042H73.9414V121.3H75.4997V118.042Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 118.039H72.2451V121.297H73.8034V118.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4987 118.043H73.9404V121.301H75.4987V118.043Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.6795 121.993H70.5693V123.63H70.6795V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2694 121.993H71.1592V123.63H71.2694V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8592 121.993H71.749V123.63H71.8592V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.45 121.993H72.3398V123.63H72.45V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0408 121.993H72.9307V123.63H73.0408V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6307 121.993H73.5205V123.63H73.6307V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2205 121.993H74.1104V123.63H74.2205V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8114 121.993H74.7012V123.63H74.8114V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4012 121.993H75.291V123.63H75.4012V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.991 121.993H75.8809V123.63H75.991V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5819 121.993H76.4717V123.63H76.5819V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1727 121.993H77.0625V123.63H77.1727V121.993Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 121.896H70.4863V122.092H77.2585V121.896Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 123.469H70.4863V123.666H77.2585V123.469Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.8026 127.773H71.9424V131.634H75.8026V127.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 128.072H72.2451V131.33H73.8034V128.072Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4997 128.076H73.9414V131.334H75.4997V128.076Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8034 128.072H72.2451V131.33H73.8034V128.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4987 128.076H73.9404V131.334H75.4987V128.076Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.6795 132.027H70.5693V133.664H70.6795V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2694 132.027H71.1592V133.664H71.2694V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8592 132.027H71.749V133.664H71.8592V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.45 132.027H72.3398V133.664H72.45V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0408 132.027H72.9307V133.664H73.0408V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6307 132.027H73.5205V133.664H73.6307V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2205 132.027H74.1104V133.664H74.2205V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8114 132.027H74.7012V133.664H74.8114V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4012 132.027H75.291V133.664H75.4012V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.991 132.027H75.8809V133.664H75.991V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5819 132.027H76.4717V133.664H76.5819V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1727 132.027H77.0625V133.664H77.1727V132.027Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 131.93H70.4863V132.126H77.2585V131.93Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2585 133.503H70.4863V133.7H77.2585V133.503Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M101.648 75.9462H91.0232V142.054H89.4492V72.0112H101.648V75.9462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.41 74.2426H63.7969L67.7319 66.896H123.475L127.41 74.2426Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.807 73.7153H63.4033V74.8958H127.807V73.7153Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M127.807 73.7153H63.4033V74.8958H127.807V73.7153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.296 60.9927H76.9131V70.3068H114.296V60.9927Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.296 60.9927H76.9131V70.3068H114.296V60.9927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6847 67.8232V62.5839H85.3958V64.747H88.0604V62.5839H88.7714V67.8232H88.0604V65.4206H85.3958V67.8232H84.6847ZM92.2523 67.928C91.7533 67.928 91.3092 67.817 90.92 67.595C90.5308 67.3704 90.2251 67.0548 90.0031 66.6481C89.781 66.239 89.67 65.7574 89.67 65.2036C89.67 64.6497 89.781 64.1694 90.0031 63.7627C90.2251 63.3536 90.5308 63.038 90.92 62.8159C91.3092 62.5914 91.7533 62.4791 92.2523 62.4791C92.7512 62.4791 93.1953 62.5914 93.5846 62.8159C93.9738 63.038 94.2794 63.3536 94.5014 63.7627C94.7235 64.1694 94.8345 64.6497 94.8345 65.2036C94.8345 65.7574 94.7235 66.239 94.5014 66.6481C94.2794 67.0548 93.9738 67.3704 93.5846 67.595C93.1953 67.817 92.7512 67.928 92.2523 67.928ZM92.2523 67.2394C92.6539 67.2394 92.9895 67.1496 93.259 66.97C93.5284 66.7878 93.7305 66.5433 93.8652 66.2365C94.0025 65.9271 94.0711 65.5828 94.0711 65.2036C94.0711 64.8243 94.0025 64.4813 93.8652 64.1744C93.7305 63.865 93.5284 63.6205 93.259 63.4409C92.9895 63.2588 92.6539 63.1677 92.2523 63.1677C91.8506 63.1677 91.515 63.2588 91.2456 63.4409C90.9761 63.6205 90.7728 63.865 90.6355 64.1744C90.5008 64.4813 90.4335 64.8243 90.4335 65.2036C90.4335 65.5828 90.5008 65.9271 90.6355 66.2365C90.7728 66.5433 90.9761 66.7878 91.2456 66.97C91.515 67.1496 91.8506 67.2394 92.2523 67.2394ZM96.5868 67.8232V63.2276H95.0599V62.5839H98.8248V63.2276H97.2979V67.8232H96.5868ZM99.5374 67.8232V62.5839H102.733V63.2276H100.248V64.762H102.224V65.4057H100.248V67.1795H102.801V67.8232H99.5374ZM103.682 67.8232V62.5839H104.393V67.1795H106.795V67.8232H103.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.996 140.48H63.2107C62.5674 140.48 62.0459 141.001 62.0459 141.645V155.087C62.0459 155.73 62.5674 156.251 63.2107 156.251H127.996C128.64 156.251 129.161 155.73 129.161 155.087V141.645C129.161 141.001 128.64 140.48 127.996 140.48Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6542 149.2L74.2327 152.572L71.2067 150.979L68.1806 152.572L68.7591 149.2L66.3115 146.816L69.6956 146.324L71.2067 143.258L72.7216 146.324L76.1057 146.816L73.6542 149.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.6543 149.2L74.2327 152.572L71.2067 150.979L68.1807 152.572L71.2067 149.007L73.6779 151.825L71.8402 148.366L75.4486 147.04L71.8166 147.433L71.2067 143.258L72.7217 146.324L76.1058 146.816L73.6543 149.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8525 149.2L86.4309 152.572L83.4049 150.979L80.3789 152.572L80.9573 149.2L78.5098 146.816L81.8939 146.324L83.4049 143.258L84.9199 146.324L88.304 146.816L85.8525 149.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.8525 149.2L86.4309 152.572L83.4049 150.979L80.3789 152.572L83.4049 149.007L85.8761 151.825L84.0385 148.366L87.6469 147.04L84.0148 147.433L83.4049 143.258L84.9199 146.324L88.304 146.816L85.8525 149.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0507 149.2L98.6292 152.572L95.6031 150.979L92.5771 152.572L93.1556 149.2L90.708 146.816L94.0921 146.324L95.6031 143.258L97.1181 146.324L100.502 146.816L98.0507 149.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M98.0507 149.2L98.6292 152.572L95.6032 150.979L92.5771 152.572L95.6032 149.007L98.0743 151.825L96.2367 148.366L99.8451 147.04L96.2131 147.433L95.6032 143.258L97.1181 146.324L100.502 146.816L98.0507 149.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.25 149.2L110.828 152.572L107.802 150.979L104.776 152.572L105.355 149.2L102.907 146.816L106.291 146.324L107.802 143.258L109.317 146.324L112.701 146.816L110.25 149.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.249 149.2L110.827 152.572L107.801 150.979L104.775 152.572L107.801 149.007L110.273 151.825L108.435 148.366L112.043 147.04L108.411 147.433L107.801 143.258L109.316 146.324L112.7 146.816L110.249 149.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.448 149.2L123.027 152.572L120.001 150.979L116.975 152.572L117.553 149.2L115.105 146.816L118.49 146.324L120.001 143.258L121.516 146.324L124.9 146.816L122.448 149.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.448 149.2L123.027 152.572L120.001 150.979L116.975 152.572L120.001 149.007L122.472 151.825L120.634 148.366L124.243 147.04L120.611 147.433L120.001 143.258L121.516 146.324L124.9 146.816L122.448 149.2Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1520_57147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196.75,
    height: 196.75,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelBookingRafiki1);
export default __webpack_public_path__ + "static/media/Hotel Booking-rafiki 1.c65b041573fc19a29cb5fecefe7cffa0.svg";
export { ForwardRef as ReactComponent };